import { SensitiveDataFormField } from "types/Models/sensitiveData";

export const getSensitiveDataEditableFields = (
  fields: SensitiveDataFormField[] = []
): SensitiveDataFormField[] => fields.filter(({ is_derived }) => !is_derived);
